import { Paragraph, shadowStandard, SizableText, SmartLink, XStack, YStack } from '@my/ui'

import { SaveOfferButton } from 'app/features/offer/containers'
import { SolitoImage } from 'solito/image'

export const ComplexOfferCard = (props) => {
  const { offer, imagePriority } = props
  const imageUri = offer?.thumbnailImage?.url || offer?.featuredImage?.url

  return (
    <YStack bg="$white" position="relative" br="$3" flex={1} {...shadowStandard}>
      {offer?.tag && (
        <XStack
          py="$1"
          px={8}
          btrr="$2"
          bbrr="$2"
          backgroundColor="$teal5"
          zIndex="$1"
          position="absolute"
          top="$3"
          left={0}
          $gtXs={{
            py: '$2',
            px: '$3.5',
          }}
        >
          <SizableText
            textTransform="uppercase"
            color="$white"
            size="$1"
            fow="700"
            $gtXs={{
              size: '$4',
              fow: '700',
            }}
          >
            {offer.tag}
          </SizableText>
        </XStack>
      )}

      <XStack zIndex="$1" position="absolute" top="$2.5" right="$2.5">
        <SaveOfferButton size={30} offerId={offer.id} isBookmarked={offer.isBookmarked} />
      </XStack>

      <SmartLink
        Component={YStack}
        href={`/discounts/${props.offer.brand.slug}/${props.offer.slug}`}
        borderRadius="$3"
        bg="$white"
        width="100%"
        flex={1}
        hoverStyle={{
          opacity: 0.9,
        }}
        pressStyle={{
          opacity: 0.8,
        }}
      >
        <YStack
          aspectRatio={9 / 5}
          $gtXs={{ aspectRatio: 11 / 7 }}
          width="100%"
          btlr="$3"
          btrr="$3"
          overflow="hidden"
        >
          <SolitoImage
            src={imageUri}
            alt={props.offer.featuredImage?.alt || props.offer.name}
            contentFit="cover"
            fill
            sizes="(max-width: 900px) 50vw, 440px"
            priority={imagePriority}
          />
        </YStack>

        <YStack gap="$2" $gtSm={{ gap: '$3.5' }}>
          <YStack
            aspectRatio={1}
            mx="auto"
            mt="$-6"
            borderRadius="$3"
            bc="$white"
            boc="$white"
            bw="$2"
            w={60}
            h={60}
            $gtSm={{ w: 100, h: 100, mt: '$-8' }}
            {...shadowStandard}
          >
            <SolitoImage
              src={props.offer.brand.logo.url}
              alt={props.offer.brand.logo.alt || props.offer.brand.name}
              contentFit="contain"
              style={{ borderRadius: 8, backgroundColor: 'white' }}
              sizes="(max-width: 1200px) 60px, 100px"
              priority={imagePriority}
              fill
            />
          </YStack>

          <YStack alignItems="center" flex={1} pb="$3.5" px="$3" $gtSm={{ pb: '$6', px: '$6' }}>
            <SizableText
              numberOfLines={2}
              textAlign="center"
              size="$4"
              fow="800"
              $gtSm={{ size: '$7', fow: '800' }}
            >
              {offer?.name}
            </SizableText>
            <Paragraph
              numberOfLines={2}
              textAlign="center"
              size="$2"
              color="$overlay11"
              pt="$1.5"
              $gtSm={{ size: '$4' }}
            >
              {offer?.description}
            </Paragraph>
          </YStack>
        </YStack>
      </SmartLink>
    </YStack>
  )
}
